import { getRoute } from 'utils/impersonate';
import biobarApi from './base/biobarApi';
import Company from 'models/Profile/Company';

export default async function getCompanyData(preferredLanguage : string) : Promise<Array<Company>> {
  const { data } = await biobarApi.get<Array<Company>>(
    `${getRoute()}/companies?` +
    `preferredLanguage=${preferredLanguage}`
  );

  return data;
}
